import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { clientsApi } from '@/api/waterlily';
import { previewClientUpdates } from '@/model';
import { clientNeedsFullIntakeForm } from '@/shared/lib/utils';

interface ValidationResult {
  needsFullIntake: boolean;
}

export function useValidatedIntakeNavigation(client: Client) {
  const dispatch = useDispatch();
  const [isValidating, setIsValidating] = useState(false);

  const validateAndDecide = useCallback(async (): Promise<ValidationResult> => {
    setIsValidating(true);
    try {
      const response = (await clientsApi.getById(client.clientId)) as unknown as ClientContainer;
      const fresh = response.client;
      if (!fresh) {
        return { needsFullIntake: clientNeedsFullIntakeForm(client) };
      }
      // Sync redux so the destination page renders against fresh client data.
      dispatch(previewClientUpdates(fresh));
      return { needsFullIntake: clientNeedsFullIntakeForm(fresh) };
    } catch {
      return { needsFullIntake: clientNeedsFullIntakeForm(client) };
    } finally {
      setIsValidating(false);
    }
  }, [client, dispatch]);

  return { validateAndDecide, isValidating };
}
